import { withTypography } from 'components/ui';

export const HeadingText = withTypography({
  variant: 'headerOne',
  textAlign: 'center',
});

export const BodyText = withTypography({ fontSize: 'md', textAlign: 'center', mb: '$4' });
